<template>
  <div class="page protocol">
    <navigation>委托代收款授权书</navigation>
    <section class="content">
      <p class="text tab-2">鉴于本人姓名：●1，身份证号码：●2，
        <strong>同意编号为●3的《“飞贷”额度借款合同》（包括《“飞贷”额度借款合同》及其组成部分）的内容，向深圳市飞贷小额贷款有限公司（以下简称“飞贷小贷”）推荐的发放贷款的机构或个人（以下称“贷款人”）申请借款，且贷款人委托飞贷小贷通过第三方支付公司或商业银行（包括但不限于宝付网络科技有限公司、通联支付网络服务股份有限公司、中国银行等，以下统称“代收款合作方”）代为收取本人作为《“飞贷”额度借款合同》中的借款人的应还款项。
        </strong>
        本人向贷款人、飞贷小贷、代收款合作方作出如下授权：
      </p>
      <p class="text">
        <strong>1、代收应还款项的范围：<span class="underline">《“飞贷”额度借款合同》约定的应当由本人偿还的全部贷款本息及清算费</span></strong>（借款人发起的提款、还款或部分还款引发的由合同以外第三方收取的资金划拨费用，以具体第三方收取为准，与飞贷无关）等相关费用（以下称“应还款项”）。
      </p>
      <p class="text">
        <strong>2、代收款银行账户范围：<span class="underline">《“飞贷”额度借款合同》约定贷款人及飞贷小贷有权扣收本人应还款项的本人名下银行账户，包括本人提供的本人名下的任一银行账户，无论该等银行账户是否被本人设定为还款账户。</span></strong>
      </p>
      <p class="text">
        <strong>3、飞贷小贷可以将本授权书项下的权利义务转委托给其关联企业代为履行及承担。</strong>
      </p>
      <p class="text">
        4、代收款合作方在接到飞贷小贷或其关联企业提供的电子委托收款指令后，将本人应还款项自动划转到飞贷小贷或其关联企业指定账户。若因代收款指令有误，导致划款错误，由飞贷小贷或其关联企业承担责任。
      </p>
      <p class="text">此外，本人同意：</p>
      <p class="text">
        <strong>1、<span class="underline">若因代收款合作方与本人银行卡账户因为业务兼容性或额度受限问题，导致应还款项代收失败或者不能一次性代收成功，本人有义务配合贷款人、飞贷小贷、代收款合作方变更还款路径、方式，并按照新的要求清偿应还款项。</span></strong>
      </p>
      <p class="text">
        <strong>2、<span class="underline">上述授权自本人以数据电文形式在本授权书上签名，即视为授权生效，一旦生效后不可撤销。</span></strong>
      </p>
      <p class="text">
        <strong>3、本授权书是《“飞贷”额度借款合同》的组成部分，与其他组成部分具备同等法律效力。本人同意本授权书未明确的事项，适用借款合同其他约定的条款。</strong>
      </p>
      <p class="text">
        <strong>4、本人确认已对本授权书的条款含义及相应的法律后果已全部知悉并充分理解。
        </strong>
      </p>
      <p class="text tab-0 margin-top-40">授权人：●4</p>
      <p class="text tab-0">日期：●5</p>
    </section>
  </div>
</template>
<script>
export default {
  name: 'fd-entrust'
}
</script>
